/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_RunningInputs */

const cs_jobs_status_running = /** @type {(inputs: Jobs_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Probíhá`)
};

const en_jobs_status_running = /** @type {(inputs: Jobs_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

/**
* | output |
* | --- |
* | "Running" |
*
* @param {Jobs_Status_RunningInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_status_running = /** @type {((inputs?: Jobs_Status_RunningInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_RunningInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_status_running(inputs)
	return cs_jobs_status_running(inputs)
});